import { Card } from '@brightdrop/bd-ui';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

import useStyles from './WizardSection.styles';

export type WizardSectionProps = {
  /** Numbers the section within the step, e.g. "1. Connect your Coast to GM Fleet". */
  number: number;
  title: string;
  /** Rendered on the same row as the title, e.g. a partner logo. */
  trailing?: ReactNode;
  children: ReactNode;
  testId?: string;
};

const WizardSection = ({
  number,
  title,
  trailing,
  children,
  testId,
}: WizardSectionProps) => {
  const { classes } = useStyles();

  return (
    // Card defaults to height: 100%, which stretches every section to fill
    // the dialog's flex column; override it so sections size to content.
    <Card
      dataTestId={testId}
      className={classes.section}
      style={{ height: 'auto' }}
    >
      <div className={classes.header}>
        <Typography variant="body_medium" component="h3">
          {number}. {title}
        </Typography>
        {trailing}
      </div>
      <div className={classes.content}>{children}</div>
    </Card>
  );
};

export default WizardSection;
